const FinalPage = () => {
  return (
    <div className='w-full h-full flex justify-center items-center'>
      <span>final page</span>
    </div>
  )
}

export default FinalPage
